// extracted by mini-css-extract-plugin
module.exports = {"text":"DateInput_text__2CCFr FormField_text__3CRh7 font_normal__3xTtI","button":"DateInput_button__95Zc7"};